module.exports = __webpack_public_path__ + "static/media/logo-localiza.f11bdf99.png";